document.addEventListener("DOMContentLoaded", function() {
    
  const shopDomain = Shopify.shop;

  const handleAddressSubmit = async event => {
    event.preventDefault();

    const formAction = document.getElementsByName("update-customer")[0].action;
    // Get the value of CartCount
    const cartCountSpan = document.getElementById("CartCount");
    const cartCountValue = cartCountSpan.innerHTML;
    const cartCountInputHidden = document.getElementById("cartCountValue");
    cartCountInputHidden.value = cartCountValue;

    const form = document.querySelector('form[name="update-customer"]');
    const formData = new FormData(form);

    // Get all required fields
    const requiredFields = form.querySelectorAll("input[required]");

    let hasError = false;

    for (let i = 0; i < requiredFields.length; i++) {
      const field = requiredFields[i];

      if (field.value.trim() === "") {
        hasError = true;
        field.style.borderColor = "red";
      } else {
        field.style.borderColor = "";
      }
    }

    if (hasError) {
      document.getElementById("login-form-error").style.display = "block";
      document.getElementById("error_address").style.display = "block";
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    // Convert FormData to JSON object
    const jsonObject = {};
    for (const [key, value] of formData.entries()) {
      jsonObject[key] = value;
    }
    const jsonBody = JSON.stringify(jsonObject);

    //Reset
    document.getElementById("login-form-error").style.display = "none";

    fetchBackend(formAction, jsonBody)
      .then(data => {
        if (cartCountValue > 0) {
          window.location.href = "/cart/checkout";
        } else {
          window.location.href = "account?redirect=address";
        }
      })
      .catch(error => {
        document.getElementById("login-form-error").style.display = "block";
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (error && error.errors && Array.isArray(error.errors)) {
          if (error.errors.includes("error_address")) {
            document.getElementById("error_address").style.display = "block";
          }
          if (error.errors.includes("error_customer")) {
            document.getElementById("error_customer").style.display = "block";
          }
        }
      });
  };

  const fetchBackend = async (url, payload) => {
    const cleanUrl = url.replace(/([^:]\/)\/+/g, "$1");
    const response = await window.fetch(cleanUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "app-shop": shopDomain
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    if (data.success == true) {
      return Promise.resolve(data);
    } else if (data.success == false) {
      return Promise.reject(data);
    } else {
      return Promise.resolve(data);
    }
  };

  document
    .querySelector(".address_submit")
    .addEventListener("click", handleAddressSubmit);
});
